import Link from '@/components/core/Link';
import styled from 'styled-components';

export const List = styled.ol`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 16px;
  gap: 8px;
  counter-reset: rules;
`;

export const ListItem = styled.li`
  width: 100%;
  color: ${({ theme }) => theme.vars.palette.text.secondary};
  font-size: 16px;
  font-weight: 400;
`;

export const StyledLink = styled(Link)`
  all: unset;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 400;
  transition: color 0.25s ease-in-out;
  color: ${({ theme }) => theme.vars.palette.text.secondary} !important;
  cursor: pointer;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    transition: background-color 0.25s ease-in-out;
    background-color: ${({ theme }) => theme.vars.palette.text.secondary};
  }

  &:hover {
    color: ${({ theme }) => theme.vars.palette.text.primary} !important;

    &::before {
      background-color: ${({ theme }) =>
        theme.vars.palette.text.primary} !important;
    }
  }
`;
